import {
  DEFAULT_KILOSORT_PARAMETERS
} from '../constants/config';

export const HYPERPARAMETER_PRESETS_STORAGE_KEY =
  'spike_dashboard_algorithm_parameter_presets';

export const CUSTOM_PARAMETER_TYPES = Object.freeze({
  NUMBER: 'number',
  STRING: 'string',
  BOOLEAN: 'boolean'
});

export const ALGORITHM_PARAMETER_DEFINITIONS = Object.freeze({
  kilosort4: [
    {
      key: 'probe_path',
      label: 'Probe Path',
      type: CUSTOM_PARAMETER_TYPES.STRING,
      placeholder: 'torchbci/data/NeuroPix1_default.mat',
      description: 'Path to probe configuration file'
    },
    {
      key: 'sampling_rate',
      label: 'Sampling Rate (Hz)',
      type: CUSTOM_PARAMETER_TYPES.NUMBER,
      numberMode: 'integer',
      min: 1000,
      description: 'Recording sampling rate'
    }
  ]
});

export function getDefaultAlgorithmParameters(algorithm) {
  if (algorithm === 'kilosort4') {
    return { ...DEFAULT_KILOSORT_PARAMETERS };
  }

  return {};
}

export function getAlgorithmParameterDefinitions(algorithm, parameters = {}) {
  const builtInDefinitions = ALGORITHM_PARAMETER_DEFINITIONS[algorithm] ||
    [];
  const builtInKeys = new Set(builtInDefinitions.map((definition) => definition.key));
  const customDefinitions = Object.keys(parameters)
    .filter((key) => !builtInKeys.has(key))
    .sort()
    .map((key) => ({
      key,
      label: formatParameterLabel(key),
      type: inferParameterType(parameters[key]),
      custom: true
    }));

  return [...builtInDefinitions, ...customDefinitions];
}

export function inferParameterType(value) {
  if (typeof value === 'boolean') return CUSTOM_PARAMETER_TYPES.BOOLEAN;
  if (typeof value === 'number') return CUSTOM_PARAMETER_TYPES.NUMBER;
  return CUSTOM_PARAMETER_TYPES.STRING;
}

export function parseParameterValue(value, definition = {}) {
  if (definition.type === CUSTOM_PARAMETER_TYPES.BOOLEAN) {
    return Boolean(value);
  }

  if (definition.type === CUSTOM_PARAMETER_TYPES.NUMBER) {
    if (value === '') return '';

    const numericValue =
      definition.numberMode === 'float'
        ? parseFloat(value)
        : parseInt(value, 10);

    return Number.isNaN(numericValue) ? '' : numericValue;
  }

  return value;
}

export function formatParameterLabel(key) {
  return key
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function normalizeParameterKey(value) {
  return value.trim().replace(/\s+/g, '_');
}

export function getPresetsForAlgorithm(presetState = {}, algorithm) {
  return presetState[algorithm] || [];
}

export function loadHyperparameterPresets() {
  try {
    const saved = localStorage.getItem(HYPERPARAMETER_PRESETS_STORAGE_KEY);
    return saved ? JSON.parse(saved) : {};
  } catch (error) {
    console.error('Error loading hyperparameter presets:', error);
    return {};
  }
}

export function saveHyperparameterPresets(presetState) {
  localStorage.setItem(
    HYPERPARAMETER_PRESETS_STORAGE_KEY,
    JSON.stringify(presetState)
  );
}

